import api from "../../composables/app";
import { API } from "../apis";

export const getAllCharacters = () => {
  return api.get(`${API.character.getAll}`);
};

export const createNew = (data) => {
  return api.post(`${API.character.create}`, data);
};

export const update = (id, data) => {
  return api.put(`${API.character.update}${id}`, data);
};
export const deleteCharacter = (id) => {
  return api.delete(`${API.character.delete}${id}`);
};
